<template>
  <div class='period-editor-container' @click.self='closeEditor' v-if='editingPeriod'>
    <div class='period-editor-body'>
      <div class='period-editor-header'>
        <div>
          <input v-model='input.title' type='text' class='dark' placeholder='Session Name' style='font-size: 1.3rem;'/>
          <div style='margin:4px 8px;'>For Event SDFDFNDF</div>
        </div>
        <div>
          <span @click='removePeriod()' v-show='!editingPeriod.unsaved'>
            <i class='fas fa-trash-alt'
            ></i>
          </span>
          <span @click='closeEditor()'>
            <i class='fas fa-times'
            ></i>
          </span>
        </div>
      </div>
      <div class='period-editor-content'>
        <div>
          <label>Start</label>
          <select v-model='input.start'>
            <option v-for='o in ticks' :value='o[0]' :key='o[1]' >{{o[1]}}</option>
          </select>
        </div>
        <div>
          <label>End</label>
          <select v-model='input.end'>
            <option v-for='o in ticks' :value='o[0]' :key='o[1]' >{{o[1]}}</option>
          </select>
        </div>
        <div>
            <label>Room</label>
            <select v-model='input.room'>
              <option v-for='room in roomOptions' :value='room.id'>{{room.name}}</option>
            </select>
        </div>
        <div>
            <label>Recurrences</label>
            <div class='group-box'>
              <div>
                <div v-for='recurrence in recurrences' class='recur-input'>
                  <div>
                    <div class='recur-label'>Start</div>
                    <select v-model='recurrence.start'>
                      <option v-for='o in ticks' :value='o[0]' :key='o[1]' >{{o[1]}}</option>
                    </select>
                  </div>
                  <div>
                    <div class='recur-label'>Room</div>
                      <select v-model='recurrence.room'>
                        <option v-for='room in roomOptions' :value='room.id'>{{room.name}}</option>
                      </select>
                  </div>
                  <div>
                    <i class='fas fa-plus'></i>
                    </div>
                </div>
                <div class='new-recur-input' @click='addRecurrence()'>
                  <div>Add Recurrence</div>
                  <div>
                    <i class='fas fa-plus'></i>
                    </div>
                </div>
              </div>
              <div class='recur-preview'>
              </div>
            </div>
        </div>
      </div>
      <div class='period-editor-footer'>
        <button 
          class='period-edit-save-btn'
          @click='save()'
        >Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import miniScheduler from "./miniScheduler";
import vSelect from "vue-select";
export default {
  props: {
    id: {
    },
    rooms: {
      default(){ return []}
    },
    editingPeriod: {
      default() {
        return null;
      }
    },
    editorVisible: {
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      input: {
        title: "",
        start: "",
        end: "",
        room: ""
      },
      stepSizeSeconds: 600,
      recurrences: []
    };
  },
  computed: {
    miniPeriods() {
      return this.recurrences.concat([this.editingPeriod]);
    },
    ticks: function() {
      if (this.editingPeriod) {
        var start = this.editingPeriod.start;
      }
      const startDay = start.day;
      var result = [];
      while (start.day === startDay) {
        result.push([start, start.toLocaleString(DateTime.TIME_SIMPLE)]);
        start = start.plus({ seconds: this.stepSizeSeconds });
      }
      return result;
    },
    roomOptions() {
      return this.rooms.concat([{name: 'none', id: null}]);
    }
  },
  methods: {
    addRecurrence() {
      this.recurrences.push({
        start: this.editingPeriod.start,
        end: this.editingPeriod.end,
        room: this.editingPeriod.room
      });
    },
    closeEditor() {
      this.$emit("update:editingPeriod", null);
    },
    setInputFields() {
      if (this.editingPeriod) {
        this.input.title = this.editingPeriod.title;
        this.input.start = this.editingPeriod.start;
        this.input.end = this.editingPeriod.end;
        this.input.room = this.editingPeriod.room;
      }
    },
    save() {
      if (this.editingPeriod.unsaved) {
        this.$emit("periodAdded", this.input);
      } else {
        this.$emit("periodUpdated", this.input);
      }
    },
    removePeriod() {
      this.$emit("periodRemoved", this.editingPeriod);
    }
  },
  watch: {
    editingPeriod: {
      deep: true,
      handler: function(v) {
        this.setInputFields();
      }
    }
  },
  components: {
    vSelect,
    miniScheduler
  },
  beforeMount: function() {
    this.setInputFields();
  }
};
</script>

<style scoped lang='scss'>
.period-editor-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: hsla(233.3, 25.7%, 13.7%, 0.7);
  color: $primary;
}
.period-editor-body {
  width: 70%;
  height: 85%;
  background: $gray-1;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
.period-editor-header {
  border-bottom: 1px solid $gray-4;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 18px 16px 12px 16px;

  > div:last-child {
    > span {
      padding: 0px 8px;
    }
    align-self: baseline;
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    font-size: 1.6rem;
  }
}
.period-editor-content {
  flex-grow: 1;
  padding: 18px 16px;
  overflow-y: auto;
}
.period-editor-footer {
  flex-shrink: 0;
}
.period-edit-save-btn {
  width: 100%;
  border: none;
  background: $green;
  align-self: flex-end;
  color: $gray-1;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  font-family: "league Spartan";
  font-size: 1.1rem;
  padding: 8px;
}
.group-box {
  display: flex;
  padding: 12px;
  border: 1px solid $gray-4;
  border-radius: 4px;
}
.new-recur-input {
  display: flex;
  background: white;
  padding: 6px 18px;
  justify-content: space-between;
  border: 1px solid $gray-4;
  border-radius: 4px;
  > div:last-child {
    padding-left: 18px;
  }
}
.recur-input {
  display: flex;
  background: white;
  padding: 8px 18px;
  justify-content: space-between;
  border: 1px solid $gray-4;
  border-radius: 4px;
  margin-bottom: 12px;
  > div:last-child {
    padding-left: 18px;
    display: flex;
    align-items: center;
  }
}
.recur-label {
  font-size: 0.8rem;
}
.recur-preview {
  display: flex;
  background: white;
  justify-content: space-between;
  border: 1px solid $gray-4;
  border-radius: 4px;
  margin-left: 12px;
  min-width: 300px;
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/event/periodEditor.vue